import { render, staticRenderFns } from "./test-view.vue?vue&type=template&id=9b71626c&scoped=true&"
import script from "./test-view.vue?vue&type=script&lang=ts&"
export * from "./test-view.vue?vue&type=script&lang=ts&"
import style0 from "./test-view.vue?vue&type=style&index=0&id=9b71626c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b71626c",
  null
  
)

export default component.exports